/**
 * Domain-aware routing utility for Trainova.
 *
 * Production domains:
 *   trainnova.se       → marketing / landing page
 *   app.trainnova.se   → application (login, dashboard, etc.)
 *
 * Preview / local:
 *   Everything on a single origin — no cross-domain redirects.
 */

const host = typeof window !== 'undefined' ? window.location.hostname : '';

/** True when running on the marketing root domain (trainnova.se, NOT app.trainnova.se). */
export const isMarketingSite = host === 'trainnova.se' || host === 'www.trainnova.se';

/** True when running on the app subdomain. */
export const isAppSite = host === 'app.trainnova.se';

/** True when running in a preview or local environment (single-origin). */
export const isPreview = !isMarketingSite && !isAppSite;

/** Absolute origin for the app subdomain. */
export const APP_ORIGIN = isPreview ? '' : 'https://app.trainnova.se';

/**
 * Build a full URL pointing to the app subdomain.
 * In preview/local mode this returns a relative path so everything stays on one origin.
 *
 *   appUrl('/login')
 *   → 'https://app.trainnova.se/login'   (production, marketing site)
 *   → '/login'                            (preview / app subdomain)
 */
export function appUrl(path) {
  return `${APP_ORIGIN}${path}`;
}
